export default function FAQSection() {
  const faqs = [
    {
      q: '黑料视频是什么？',
      a: '黑料视频是一个专注于娱乐圈、网红圈和社会热点爆料的资讯平台，提供最新黑料视频在线观看与下载，24小时不间断更新。',
    },
    {
      q: '黑料视频的内容来源是什么？',
      a: '我们的内容来自多方渠道整合，包括网友投稿、媒体公开报道以及内部线人独家爆料，所有内容均经过专业团队审核。',
    },
    {
      q: '黑料视频是否免费？',
      a: '是的，黑料视频所有内容均免费浏览。我们致力于为用户提供最新最全的吃瓜资讯，不收取任何费用。',
    },
    {
      q: '如何投稿爆料？',
      a: '您可以通过关于我们页面的联系方式进行投稿，我们会对有价值的爆料内容给予相应奖励。',
    },
    {
      q: '黑料视频更新频率如何？',
      a: '黑料24小时不打烊，我们每天至少更新10条以上最新爆料内容，确保您不会错过任何热点资讯。',
    },
  ];

  const faqJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.q,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.a,
      },
    })),
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqJsonLd) }}
      />
      <section className="max-w-[900px] mx-auto px-4 md:px-6 py-14 md:py-20">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            <a href="#faq-section" className="hover:text-primary-600 transition-colors">常见问题</a>
          </h2>
        </div>
        <div className="flex flex-col gap-4">
          {faqs.map((faq, i) => (
            <details key={i} className="group border border-background-200/70 rounded-lg overflow-hidden bg-background-50">
              <summary className="flex items-center justify-between p-5 cursor-pointer hover:bg-background-100 transition-colors">
                <span className="text-sm md:text-base font-medium text-foreground-900 pr-4">{faq.q}</span>
                <span className="w-5 h-5 flex items-center justify-center shrink-0 text-foreground-400 group-open:rotate-180 transition-transform">
                  <i className="ri-arrow-down-s-line"></i>
                </span>
              </summary>
              <div className="px-5 pb-5 text-sm text-foreground-600 leading-relaxed">{faq.a}</div>
            </details>
          ))}
        </div>
      </section>
    </>
  );
}